import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { UniversalConfig } from '@application/universal_config.service';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { CookiePolicy } from '@view/cookie_policy/mod';
import { createRoot, Root } from 'react-dom/client';
import { Route, Routes } from 'react-router-dom';
import { sharedResolution } from '../../src/shared_resolution';
import { StartupService } from '../app/Services/app/startup.service';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'CookiePolicyWrapper';

@Component({
	standalone: false,
	selector: 'cookie-policy-component',
	template: `
		<semantic-view>
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
	styles: [
		`
			p,
			span,
			h1,
			h2,
			h3,
			h4,
			h5,
			h6,
			h7,
			h8,
			h9 {
				margin-bottom: 0;
			}
		`,
	],
})
export class CookiePolicyWrapperComponent implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;
	public extraHeaderHeight: boolean = false;

	constructor(private readonly ngZone: NgZone) {}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private async render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const universalConfigService = sharedResolution.resolve(UniversalConfig);

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<ProgrammaticBrowserRouter basename={universalConfigService.alias} forceNewHistory>
						<Routes>
							<Route path='cookie-policy/*' element={<CookiePolicy />} />
						</Routes>
					</ProgrammaticBrowserRouter>
				</CellulaProviderWrapper>,
			);
		});
	}
}
